import type { InsuranceCheckRequirement } from "@medbillai/generated-graphql-types";
import { Body3, Card, Display4, YStack } from "@medbillai/ui";
import { analyticsService } from "../../../lib/analytics";
import { AddInsuranceHeader } from "./PlanHeader";
import { askingDetail, PlanSetupForm, SetupChecking } from "./PlanSetupForm";
import { SetupIllustration } from "./SetupIllustration";
import type { PlanSetup } from "./usePlanSetup";
const HEADLINE = "Your insurance, made simple.";
export function SetupCard({
  setup,
  missing
}: {
  setup: PlanSetup;
  missing: InsuranceCheckRequirement[];
}) {
  return <Card variant="raised" size="large" padding="$sp2" testID="coverage.setup" data-sentry-element="Card" data-sentry-component="SetupCard" data-sentry-source-file="SetupCard.tsx">
      {setup.checking ? <SetupIllustration /> : <SetupHead />}
      <PlanSetupForm setup={setup} missing={missing} data-sentry-element="PlanSetupForm" data-sentry-source-file="SetupCard.tsx" />
    </Card>;
}

/** The uninsured root: adding insurance opens the setup sheet. */
export function UninsuredSetup({
  setup
}: {
  setup: PlanSetup;
}) {
  return setup.checking ? <Card variant="raised" size="large" padding="$sp2" data-sentry-element="Card" data-sentry-component="UninsuredSetup" data-sentry-source-file="SetupCard.tsx">
      <SetupIllustration data-sentry-element="SetupIllustration" data-sentry-source-file="SetupCard.tsx" />
      <SetupChecking detail={askingDetail(setup.insurer?.carrier ?? "")} data-sentry-element="SetupChecking" data-sentry-source-file="SetupCard.tsx" />
    </Card> : <AddInsuranceHeader onPress={() => {
    analyticsService.trackEvent("CoverageAddInsuranceTapped", {
      source: "uninsured"
    });
    setup.openSheet();
  }} data-sentry-element="AddInsuranceHeader" data-sentry-component="UninsuredSetup" data-sentry-source-file="SetupCard.tsx" />;
}
function SetupHead() {
  return <YStack data-sentry-element="YStack" data-sentry-component="SetupHead" data-sentry-source-file="SetupCard.tsx">
      <SetupIllustration data-sentry-element="SetupIllustration" data-sentry-source-file="SetupCard.tsx" />
      <Display4 color="$textDefault" marginTop="$sp2" marginBottom="$sp1" data-sentry-element="Display4" data-sentry-source-file="SetupCard.tsx">
        {HEADLINE}
      </Display4>
      <Body3 color="$textSubtle" data-sentry-element="Body3" data-sentry-source-file="SetupCard.tsx">
        A few details and we pull your plan straight from your insurer:
        deductible, out-of-pocket max, what each visit costs.
      </Body3>
    </YStack>;
}